<div class="stories-header">
    <div class="stories-header-wrapper container-fluid">
        <div class="container d-flex h-100">
            <div class="col-md-12 col-lg-8 d-flex align-content-end align-items-end">
                <div class="stories-header--content flex-column flex-sm-row">
                    <!-- Accessiblity -->
                    <h1 style="display:none" role="heading">{{currentPage.name}}</h1>
                    <div class="stories-header--image" [style.background-image]="'url(' + currentPage.meta.icon + ')'"></div>
                    <div class="stories-header--details" [innerHTML]="block.data.text ? block.data.text : block.data.heading"></div>
                </div>
            </div>
        </div>
    </div>
</div>
